import React from 'react'
import '../../App.css'

export default function Projects() {
    return <h1 className="projects">Sorry Github for this project is private for now. Please contact me for more information.</h1>
}